// covered-by: frontends/carrie/src/config/__tests__/posthog.test.ts
// why: `t` is the session JWT on this origin (auth derive reads it; projects.ts writes it), not a general query param
const SESSION_QUERY_KEYS = ["refreshedToken", "t"] as const;

/** URL properties posthog-js copies off `location.href` onto each event. */
const SESSION_URL_PROPERTIES = [
  "$current_url",
  "$session_entry_url",
  "$initial_current_url",
] as const;

/**
 * Drop session-handoff query keys from a URL before analytics records it.
 * `refreshedToken` and `t` are JWTs. PostHog and Datadog both capture the
 * page URL, and the auth slice strips them from the address bar only after
 * the first pageview can already have been queued.
 */
export function scrubSessionQuery(url: string): string {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return url;
  }
  const hadSessionKey = SESSION_QUERY_KEYS.some((key) =>
    parsed.searchParams.has(key),
  );
  if (!hadSessionKey) return url;
  for (const key of SESSION_QUERY_KEYS) {
    parsed.searchParams.delete(key);
  }
  return parsed.toString();
}

/** Strip session JWTs from the URL properties on one analytics event. */
export function scrubSessionProperties(
  properties: Record<string, unknown> | null | undefined,
): void {
  if (properties == null) return;
  for (const key of SESSION_URL_PROPERTIES) {
    const value = properties[key];
    if (typeof value !== "string") continue;
    properties[key] = scrubSessionQuery(value);
  }
}
